import {Fragment, useContext} from "react";
import {MyContext} from "../context/myContext";

const PasswordFormInput = ({state, handleChange, handleShowPassword}) => {
    const {data, selectedUser} = useContext(MyContext)
    return(
        data.map((item, index) => {
            return(
                <Fragment key={index}>
                    <label>{item.label}{item.id !== 'username' && <span>*</span>}</label>
                    <div className="password-container">
                        {item.id !== 'username' && <i className={`${state.showPass[item.id] ? 'fa fa-eye-slash' : 'fa fa-eye'} eye-icon`} id={item.id} onClick={handleShowPassword}></i>}
                        <input type={state.showPass[item.id] === false ? 'password' : 'text'} name={item.name} value={item.id !== 'username' ? state.password[item.name] : ''} placeholder={item.id !== 'username' ? item.label : selectedUser.userName} onChange={handleChange} readOnly={item.id === 'username'} />
                    </div>
                </Fragment>
            )
        })
    )
}

export default PasswordFormInput